<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Sponsor Pribadi</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Sponsor Pribadi</div>
		</div>
		
		<div class="mt-5">
			<v-card class="pa-3 mb-4 elevation-0 rounded-lg hover-shadow bg-primary-light">
				<v-row v-if="dataSponsorisasi" class="d-flex align-center justify-space-between">
					<v-col cols="12" sm="8" md="9">
						<v-row>
							<v-col cols="12" sm="6" md="3">
								<div class="d-flex align-center">
									<v-icon
										class="cl-grey"
										x-large
									>mdi-account-circle-outline</v-icon>
									<div class="d-block pl-4">
										<div class="font-size-12 font-size-xs-11 cl-grey font-weight-500">Kode Mitra</div>
										<span class="font-size-13 font-size-xs-12 font-weight-500">{{ dataSponsorisasi.network_code }}</span>
									</div>
								</div>
							</v-col>
							<v-col cols="12" sm="6" md="3">
								<div class="d-flex align-center">
									<v-icon
										class="cl-grey"
										x-large
									>mdi-account-network-outline</v-icon>
									<div class="d-block pl-4">
										<div class="font-size-12 font-size-xs-11 cl-grey font-weight-500">Level</div>
										<span class="font-size-13 font-size-xs-12  font-weight-500">{{ dataSponsorisasi.level }}</span>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="4" md="3" class="text-right my-auto" v-if="dataSponsorisasi.level > 0">
						<v-btn depressed color="white rounded-lg" @click="backSponsor(dataSponsorisasi.sponsor_network_id, dataSponsorisasi.sponsor_network_code)">
							<span class="pr-2 cl-primary-2 text-capitalize">Level Sebelumnya</span>
							<v-icon class="cl-primary-2">mdi-arrow-up-circle</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-card>

			<div class="mt-3" v-if="!loading">
				<v-row v-if="listSponsorisasi.length > 0">
					<v-col cols="12" sm="12" md="12">
						<v-card class="pa-3 mb-3 elevation-0 rounded-lg hover-shadow" v-for="sponsor in listSponsorisasi" :key="sponsor.network_id">
							<v-row class="cursor-pointer" @click="getSponsor(sponsor.network_id, sponsor.network_code)">
								<v-col cols="6" sm="2" md="1" class="pr-3 pr-sm-0 pr-md-3">
									<v-img height="65" width="65" class="user-img mx-auto rounded-pill" :src="(sponsor.image_url) ? sponsor.image_url : '/assets/image/profile-pict.png'"></v-img>
								</v-col>
								<v-col cols="6" sm="3" md="2">
									<div>
										<div class="font-size-11 font-size-xs-11 cl-primary font-weight-600">{{ sponsor.network_code }}</div>
										<div class="font-size-10 font-size-xs-10 text-uppercase cl-secondary font-weight-500">{{ sponsor.member_name }}</div>
										<template v-if="sponsor.city_name">
											<div class="font-size-10 cl-grey">{{ sponsor.city_name ? sponsor.city_name : '-' }}</div>
										</template>
										<template v-else>
											<div class="font-size-10 cl-grey">Kota {{ sponsor.city_name ? sponsor.city_name : '-' }}</div>
										</template>
									</div>
								</v-col>
								<v-col cols="6" sm="3" md="2">
									<div class="pt-0">
										<div class="font-size-10 cl-grey">Tgl. Pendaftaran</div>
										<div class="font-size-11 font-size-xs-10 cl-secondary font-weight-500">{{ sponsor.member_join_datetime | tanggal }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="4" md="3">
									<div class="pt-0">
										<div class="font-size-10 cl-grey">Nomor HP / Email</div>
										<div class="font-size-10 font-size-xs-10 cl-secondary font-weight-500">{{ sponsor.member_mobilephone | emptyData }}</div>
										<div class="font-size-10 font-size-xs-10 cl-secondary font-weight-500">{{ sponsor.member_email | emptyData }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="2" md="2">
									<div class="pt-0 text-sm-center">
										<div class="font-size-10 cl-grey">Sponsoring</div>
										<div class="font-size-11 font-size-xs-11 cl-secondary font-weight-600">{{ sponsor.network_total_sponsoring | toNumber }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="4" md="2">
									<div class="pt-0 text-md-right">
										<div class="font-size-10 cl-grey">Kemitraan</div>
										<div class="d-flex align-center justify-md-end" v-if="sponsor.network_type">
											<div class="font-size-10 font-size-xs-10 font-weight-600">
												<div class="text-uppercase" :style="{color: getNetworkTypeColor(sponsor.network_type)}">{{ (sponsor.network_type === 'gold') ? 'Gold Star' : (sponsor.network_type === 'repeat_order') ? 'Silver' : sponsor.network_type }}</div>
											</div>
											<div class="my-2">
												<v-img width="36" style="height: auto;max-width: 100%;" class="ml-3" :src="getNetworkTypeBadge(sponsor.network_type)"></v-img>
											</div>
										</div>
									</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>

				<div class="mt-3" v-if="listSponsorisasi.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data sponsorisasi yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div v-if="listSponsorisasi.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="sponsorisasiPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ sponsorisasiPagination.total_display }} data dari total {{ sponsorisasiPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>

			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			network_id: '',
			network_code: '',
			networkType: null,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '',
					classText: 'mitra-pra'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				}
			],
		}
	},
	computed: {
		...mapState('network', ['listSponsorisasi', 'sponsorisasiPagination', 'dataSponsorisasi']),
	},
	methods: {
		...mapActions('network', ['getSponsorisasi']),

		getSponsor(id, code) {
			this.network_id = id
			this.network_code = code
			this.getData()
		},
		backSponsor(id, code) {
			this.network_id = id
			this.network_code = code
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getNetworkTypeBadge(type) {
			if(type === 'repeat_order') type = 'silver'
			const netType = this.kemitraan.find(x => x.type === type)
			if(netType) return netType.badges
		},
		getNetworkTypeColor(type) {
			if(type === 'repeat_order') type = 'silver'
			const netType = this.kemitraan.find(x => x.type === type)
			if(netType) return netType.color
		},
		getData() {
			this.loading = true
			let params = {limit:this.limit, page: this.page}
			if (this.network_id) {
				params.network_id = this.network_id
			}
			if (this.network_code) {
				params.network_code = this.network_code
			}
			this.getSponsorisasi(params).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	watch: {
		// $route(val) {
		// 	this.getSponsorisasi({network_code:val.params.network_code})
		// }
	},
	created(){
		this.$store.dispatch('setPageTitle', `Sponsor Pribadi`)
		this.getData()
	},
};
</script>

